import { has } from 'lodash'

export function hasKeys(obj: Record<string, any>, keys: string[]): boolean {
  return keys.every(key => has(obj, key))
}
